export default __webpack_public_path__ + "static/media/left-arrow-white.c8e09400.svg";